
import {buildPagination} from "./buildPagination.js";
import {buildCreatorsArray} from "./buildCreatorsArray.js"

export function grabDatabaseComics(response){
  
    var comicDetailsArray ;
    var comicsCollectionArray = [];


    try{    
        var comicsDataRetreived = response.data.data.results;
        comicsDataRetreived.forEach(function(item,index){
            

            //clean up what you need for a list of creators and positions
            var creatorsListData = response.data.data.results[index].creators.items;
            
            //external function just to keep this one neater. it takes the creators data and organizes
            //it into something we can use for display later in the render
            var creatorsArray = buildCreatorsArray(creatorsListData);
            
            //make an array of the characters in the issue. This array will be included in each comicDetailsArray[]
            //turns out this will be done in grabCharacters(), but what the hell
            var characterListData = response.data.data.results[index].characters.items;
                     
            var charactersArray = [];
            characterListData.forEach(function(item,index){
                charactersArray.push(item.name); 
            });


            //remover <html> tags that sometimes show up in the descriptions
            var description = response.data.data.results[index].description;
            if(description != null){
                var noUL = description.replace("<ul>","");
                var noUlClose = noUL.replace("</ul>","");
                var noLi = noUlClose.replace("<li>","");
                var noLiClose = noLi.replace("</li>","");
                var noBr = noLiClose.replace("<br>","");
                 noBr = noBr.replace("<li>","");//for some reason we had to hit the <li>s twice
                 noBr = noBr.replace("</li>","");
                 noBr = noBr.replace("&rsquo;","'");//replace comma HTML code with comma
                var cleanDescription = noBr;
            }
            else if(description === null){
                cleanDescription = "I have no record of a description for " + response.data.data.results[index].title;
            }

            //replace marvels shitty "image not found" image with mine
            if(response.data.data.results[index].thumbnail.path === "http://i.annihil.us/u/prod/marvel/i/mg/b/40/image_not_available"){
                var finalImage ="http://www.webnamehere.com/jarvis/images/comic-not-found.gif";
            }
            else{
                var finalImage = response.data.data.results[index].thumbnail.path + "." +response.data.data.results[0].thumbnail.extension;
            }

            //im storing the total of all characters marvels API finds for pagination purposes
            //ill store it in each character bc i dont want to restructure this array
            comicDetailsArray = [
                response.data.data.results[index].title,
                cleanDescription,
                finalImage,
                response.data.data.results[index].id,
                response.data.data.results[index].format,
                response.data.data.results[index].pageCount,
                charactersArray,
                creatorsArray,
                response.data.data.total
            ]

            comicsCollectionArray.push(comicDetailsArray);
        });//end comicsDataRetreived.forEach()

        //just grab the first items 'total' value. 
        //pass it into buildPagination() along with how many characters will show on the page
        var total = comicsCollectionArray[0][8];
        var pagination = buildPagination(24,total);
        
        comicsCollectionArray.push(pagination);
        //console.log(comicsCollectionArray);

    }//end try
    catch(error) {
        console.log("Couldnt grab a comic in grabDatabaseComics.js" + error);
    }

    console.log(comicsCollectionArray); 

    comicsCollectionArray.forEach(function(item,index){
        if(item[6].length === 0){
            item[6].push("No Characters Listed");
        }
    });

    return comicsCollectionArray;

}//end grabCharacters()


// WEBPACK FOOTER //
// ./src/components/includes/grabDatabaseComics.js